export enum CategoryDispatchTypes {
  FETCH_CATEGORIES = 'FETCH_CATEGORIES',
  START_FETCHING_CATEGORIES = 'START_FETCHING_CATEGORIES',
  STOP_FETCHING_CATEGORIES = 'STOP_FETCHING_CATEGORIES'
}
